module.exports = __webpack_public_path__ + "static/img/frame.ca468ece.png";